<template>
  <div class="container">
    <div class="content-inner-wrap">
      <div class="data-filter">
        <span class="mgr25">选择日期</span>
        <el-date-picker
          v-model="proIncomeDate"
          type="daterange"
          align="left"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
          :picker-options="pickerOptions"
          @change="proIncomeDateChangeFn"
        >
        </el-date-picker>
        <el-button @click="ProIncomeBtnClicked" class="search_btn" type="info">
          查找
        </el-button>
        <!-- <span class="download-wrap" @click="exportFn">
          <img src="@/assets/images/icon_export.png" />
          <span>导出数据</span>
        </span> -->
      </div>
      <div class="sort-wrap">
        <span class="sort-box">
          <span class="title">排序：</span>
          <div
            class="sort-content"
            :key="index"
            v-for="(item, index) in sortInArr"
            @click="changeInSort(index)"
          >
            {{ item.title }}
            <span class="el-icon" v-if="activeSort == index">
              <i class="el-icon-back"> </i>
            </span>
            <span class="el-icon-new" v-else><i class="el-icon-back"></i></span>
            <span class="el-border" v-if="index != sortInArr.length - 1"></span>
          </div>
        </span>
        <span class="download-wrap" @click="exportFn">
          <img src="@/assets/images/icon_export.png" />
          <span>导出数据</span>
        </span>
      </div>
      <div class="data-table">
        <el-table :data="IncomeData" :cell-style="cellStyle" stripe>
          <el-table-column label="作品名称" prop="name" align="center" fixed>
          </el-table-column>
          <el-table-column label="作品类型" prop="ctype" align="center">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.ctype === 1
                    ? '地图'
                    : scope.row.ctype === 2
                    ? '游戏'
                    : scope.row.ctype
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="迷你豆数量" prop="minibean" align="center">
          </el-table-column>
          <el-table-column label="迷你点数量" prop="minipoint" align="center">
          </el-table-column>
          <el-table-column
            label="贡献点数量"
            prop="contribution"
            align="center"
          >
          </el-table-column>
          <el-table-column label="广告收入" align="center">
            <el-table-column
              label="触发器收入"
              prop="ad_trigger"
              align="center"
            >
              <template slot="header">
                <el-tooltip placement="top">
                  <span
                    >触发器收入
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    在地图作品中，用户通过触发器观看的广告记为内购商店广告，该收入是广告收入的一部分。
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="内购商店收入" prop="ad_shop" align="center">
              <template slot="header">
                <el-tooltip placement="top">
                  <span
                    >内购商店收入
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    在地图作品中，用户通过观看开发者商店内商品的广告记为内购商店广告，该收入是广告收入的一部分。
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="通行证收入"
              prop="ad_passcheck"
              align="center"
            >
              <template slot="header">
                <el-tooltip placement="top">
                  <span
                    >通行证收入
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    在地图作品中，用户通过观看畅玩通行证的广告记为通行证广告，该收入是广告收入的一部分。
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="其他广告收入"
              prop="ad_other"
              align="center"
            >
            </el-table-column>
            <el-table-column label="合计" prop="ad_income" align="center" fixed>
            </el-table-column>
          </el-table-column>
          <!-- <el-table-column label="会员收入" prop="minipoint" align="center">
          </el-table-column> -->

          <!-- prop="other" -->
          <el-table-column label="激励金收入" align="center">
            <el-table-column
              label="星启激励A收入"
              prop="xq4_time"
              align="center"
            >
              <template slot="header">
                <el-tooltip placement="top">
                  <span>
                    星启激励A收入
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>
                  <p slot="content" style="font-size: 16px; color: #fff">
                    2024年7-2025年1月为星启6.0时长激励，2024年1-6月为星启5.0内购时长激励，2023年为星启4.0时长激励
                  </p>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.xq4_time || 0 }}
              </template>
            </el-table-column>
            <el-table-column
              label="星启激励B收入"
              prop="xq4_shop"
              align="center"
            >
              <template slot="header">
                <el-tooltip placement="top">
                  <span>
                    星启激励B收入
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>
                  <p slot="content" style="font-size: 16px; color: #fff">
                    2025年2月及以后为星启7.0内购激励，2024年7-2025年1月为星启6.0内购激励，2024年1-6月为星启5.0广告激励，2023年为星启4.0内购激励
                  </p>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.xq4_shop || 0 }}
              </template>
            </el-table-column>
            <el-table-column label="星启3.0计划收入" prop="xq3" align="center">
              <template slot="header">
                <el-tooltip placement="top">
                  <span>
                    星启3.0计划收入
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>
                  <p slot="content" style="font-size: 16px; color: #fff">
                    创作者的作品在满足条件后根据游戏时长、地图质量评定等条件可获得对应的游戏时长激励奖金。
                  </p>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.xq3 || 0 }}
              </template>
            </el-table-column>
            <el-table-column label="合计" align="center">
              <template slot-scope="scope">
                {{ getOtherSum(scope.row) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="发布时间" prop="upload_time" align="center">
          </el-table-column>
          <el-table-column align="center" fixed="right">
            <template slot="header"><span>详情</span> </template>
            <template slot-scope="scope">
              <span class="all-look" @click="mapDetailClick(scope.row.id)">
                查看详情
              </span>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="img-no" v-if="showDefault">
              <img
                class="img-no-data"
                src="@/assets/images/img_table_no_data.png"
              />
              <div class="noCart">暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>

      <div class="data-filter-page">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :total="IncomeDataPageCount"
          @current-change="PaginationChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { exportProIncome, getProductIncome } from '@/api/income';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
export default {
  data() {
    return {
      proIncomeDataLoading: false,
      IncomeDataPageCount: 0,
      IncomeData: [],
      showDefault: false,
      proIncomeDate: [],
      Pagination: {
        page_size: 10,
        page: 1,
      },
      sort_type: 4,
      activeSort: 0,
      sortInArr: [
        { title: '发布时间' },
        { title: '迷你豆数量' },
        { title: '迷你点数量' },
        { title: '贡献点数量' },
        { title: '广告收入' },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.proIncomeDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  mounted() {
    this.getIncomeData();
  },
  watch: {
    IncomeData(val) {
      val.length ? (this.showDefault = false) : (this.showDefault = true);
    },
  },
  methods: {
    proIncomeDateChangeFn() {
      if (this.proIncomeDate) window.__time__ = this.proIncomeDate[0];
    },
    mapDetailClick(tid) {
      this.$router.push({ path: '/charts/detail', query: { id: tid } });
    },
    cellStyle(column) {
      let cellStyle;
      if (column.columnIndex === 10) {
        cellStyle = 'padding:0;';
      }
      return cellStyle;
    },
    changeInSort(index) {
      this.activeSort = index;
      switch (index) {
        case 0:
          this.sort_type = 4;
          break;
        case 1:
          this.sort_type = 6;
          break;
        case 2:
          this.sort_type = 7;
          break;
        case 3:
          this.sort_type = 8;
          break;
        case 4:
          this.sort_type = 9;
          break;
        default:
          break;
      }
      this.getIncomeData();
    },
    toastMessage() {
      // this.$message.error('仅能查看签约成员数据哦');
    },
    ProIncomeBtnClicked() {
      if (this.proIncomeDate) {
        this.getIncomeData();
      }
    },
    PaginationChange(currPage) {
      this.Pagination.page = currPage;
      this.getIncomeData();
    },
    exportFn() {
      this.fetchExport();
    },
    //导出收益明细数据
    async fetchExport() {
      let data = {
        start_time: parseInt(this.proIncomeDate[0] / 1000, 10),
        end_time: parseInt((this.proIncomeDate[1] + ONE_DAY_TIME) / 1000, 10),
        income_type: 1,
      };
      try {
        const res = await exportProIncome(data);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    getOtherSum(data) {
      // 激励金合计
      let sums = 0;
      sums =
        this.filterNumberType(data.xq3) +
        this.filterNumberType(data.xq4_time) +
        this.filterNumberType(data.xq4_shop);
      return sums;
    },
    filterNumberType(val) {
      if (typeof val !== 'number') {
        return 0;
      }
      return Number(val);
    },
    //下载数据
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    routeDate(time) {
      let date = new Date(time * 1000);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      //console.log(time);
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      return year + '-' + month + '-' + day;
    },
    async getIncomeData() {
      this.proIncomeDataLoading = true;
      //this
      let data = {
        start_time: parseInt(this.proIncomeDate[0] / 1000, 10),
        end_time: parseInt((this.proIncomeDate[1] + ONE_DAY_TIME) / 1000, 10),
        page_size: this.Pagination.page_size,
        page: this.Pagination.page,
        income_type: '1',
        sort_type: this.sort_type,
      };
      const res = await getProductIncome(data);
      this.proIncomeDataLoading = false;
      this.IncomeData = res.data.list.map(item => {
        item.contribution = Number(item.contribution).toFixed(3);
        item.minibean = item.minibean | 0;
        item.minipoint = item.minipoint | 0;
        item.contribution = item.contribution | 0;
        item.ad_other = item.ad_other | 0;
        item.ad_shop = item.ad_shop | 0;
        item.ad_trigger = item.ad_trigger | 0;
        item.ad_passcheck = item.ad_passcheck | 0;
        item.ad_income = item.ad_income | 0;
        item.other = item.other | 0;
        item.upload_time = this.routeDate(item.upload_time);
        return item;
      });
      // this.IncomeData = [];
      this.IncomeDataPageCount = parseInt(res.data.total_count, 10);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  margin-top: 30px;
  .content-inner-wrap {
    .data-filter {
      margin-bottom: 22px;
      .mgr25 {
        margin-right: 25px;
      }
      .search_btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0;
        color: #595959;
        border-right: 1px solid #d9d9d9;
        border-top: 1px solid #d9d9d9;
        border-bottom: 1px solid #d9d9d9;
        background-color: #f4f4f5;
      }
      .download-wrap {
        float: right;
        border-radius: 4px;
        font-size: 11px;
        // font-weight: 600;
        margin-top: 18px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #2b6ddf;
        img {
          margin-right: 8px;
        }
      }
    }
    .sort-wrap {
      display: flex;
      .title {
        font-size: 14px;
        margin-top: 0;
      }
      .el-icon {
        .el-icon-back {
          transform: rotate(-90deg);
        }
      }
      .el-icon-new {
        opacity: 0;
      }
      .sort-content {
        margin-right: 5px;
        cursor: pointer;
        .el-border {
          border-right: 2px solid #d8d8d8;
          margin-right: 4px;
        }
      }
      .sort-box {
        display: flex;
        width: 92%;
      }
      .download-wrap {
        //float: right;
        //display: block;
        //margin-right: 150px;
        border-radius: 4px;
        font-size: 11px;
        //background-color: #595959;
        // font-weight: 600;
        //margin-top: 13px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
        color: #2b6ddf;
        img {
          margin-right: 8px;
        }
      }
    }
    .data-table {
      margin-top: 28px;
      border: 1px solid #d9d9d9;
      overflow: hidden;
      border-radius: 3px;
      ::v-deep .el-table tr:last-child td {
        border-bottom: none;
      }
      ::v-deep .el-table::before {
        background: transparent;
      }
      ::v-deep .el-table th {
        background: #fafafa;
        line-height: 29px;
      }
      ::v-deep.el-table td {
        line-height: 29px;
        padding: 7px 0 6px;
      }
      ::v-deep.el-table .cell {
        padding: 0;
      }
      // ::v-deep.el-table_1_column_12 .is-center td {
      //   width: 95px;
      //   padding: 0 3px;
      //   background: blue;
      //   .cell {
      //     padding: 0 3px;
      //     background: blue;
      //   }
      // }
      // ::v-deep.el-table_1_column_12 .is-center.is-leaf {
      //   width: 95px;
      //   padding: 0 3px;
      //   background: blue;
      //   .cell {
      //     padding: 0 3px;
      //     background: blue;
      //   }
      // }
      img.icon-help {
        height: 10px;
        width: 10px;
      }
      .all-look {
        color: #2b6ddf;
        // text-decoration: underline;

        display: flex;
        cursor: pointer;
        justify-content: center;
      }
      .img-no {
        margin-top: 15px;
        .noCart {
          margin-top: -20px;
        }
      }
    }
    .data-filter-page {
      margin-top: 44px;
      text-align: center;
      margin-bottom: 12px !important;
      ::v-deep .el-pagination.is-background .el-pager li,
      ::v-deep .el-pagination.is-background .btn-prev,
      ::v-deep .el-pagination.is-background .btn-next {
        width: 31px;
        height: 31px;
        border-radius: 4px;
        margin: 0 4.5px;
        background-color: #fff;
        color: #8c8c8c;
        border: 1px solid #d9d9d9;
      }
      ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #fffaed;
        color: #fd9b21;
        border-color: #ffc973;
      }
    }
  }
}
</style>
